import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Notification } from '@ml/notifications/types/interfaces';

@Component({
  selector: 'ml-notifications-list',
  template: `
    <ng-container *ngIf="notifications; else loading">
      <ng-container *ngIf="notifications.length !== 0; else noNotifications">
        <ml-notification-item
          *ngFor="let notification of notifications"
          [notification]="notification"
          (remove)="remove.emit(notification)"
          (redirect)="redirect.emit(notification)"
        >
        </ml-notification-item>
        <div
          *ngIf="next"
          class="full-width margin-top-16"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <button
            mat-button
            [disabled]="loadingMore"
            color="primary"
            class="load-more-button"
            (click)="loadMore.emit()"
          >
            <div *ngIf="!loadingMore; else loadingMoreComments">
              {{ 'load more' | translate | sentancecase }}
            </div>
            <ng-template #loadingMoreComments>
              <mat-spinner
                [diameter]="24"
                color="primary"
                style="margin: auto"
              ></mat-spinner>
            </ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #noNotifications>
        <div class="text-center mat-subheading-2">
          {{ 'no-notifications' | translate | sentancecase }}
        </div>
      </ng-template>
    </ng-container>
    <ng-template #loading>
      <div fxLayoutAlign="center">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </ng-template>
  `,
  styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent implements OnInit {
  @Input() notifications: Notification[];
  @Input() next: boolean;
  @Input() loadingMore: boolean;
  @Output() loadMore = new EventEmitter();
  @Output() remove = new EventEmitter<Notification>();
  @Output() redirect = new EventEmitter<Notification>();
  constructor() {}

  ngOnInit() {}
}
